<template>
  <button class="hover:border-gray-600 focus:outline-none"
          @click='$emit("select", image)'
          :class='isSelected ? "bg-blue-400" : ""'
          :key='image.url'>
      <div class="object-cover mx-auto spritesheet-bg-image"
           :class='!inViewport ? "spritesheet-lazy" : ""'
          loading="lazy"
          :style='style' />
  </button>

</template>
<script>
export default {
  props:{
    image:{
      type:Object,
      required:true
    },
    isSelected:{
      type:Boolean,
      default:false
    },
    inViewport:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      lastPosX:-1,
      lastPosY:-1,
      bounds:{
        width:0,
        height:0
      },
    }
  },
  methods:{
    getOffset(el) {
      const parent = this.$el.parentNode.parentNode;
      var _x = 0;
      var _y = 0;
      while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
      }
      _x -= parent.scrollLeft;
      return { top: _y, left: _x };
    },
    deselect() {
    },
    calculateBounds() {
      const bb = this.$el.getBoundingClientRect();
      this.bounds.width = bb.width;
      this.bounds.height = bb.height;
      //console.log('calculate bounds', this.bounds);
    }
  },
  mounted() {
    this.calculateBounds();
  },
  beforeDestroy() {
  },
  watch:{
    isSelected:{
      handler(nv) {
      },
      immediate:true
    }
  },
  computed: {
    style() {
      if (this.bounds.width === 0) {
        console.warn('bailing cos of width');
        return {}
      }
      const bb = this.bounds;
      const url = this.image.url;
      const tilespec = this.image.tilespec;
      const left = tilespec.frame.x;
      const top = tilespec.frame.y;
      const width = tilespec.frame.w;
      const height = tilespec.frame.h;
      const scalex = bb.width / width;
      const scaley = bb.height / height;
      const scale = Math.min(scalex, scaley);
      const dx = 0;
      const dy = 0;
      const style = {
        width: `${width}px`,
        height: `${height}px`,
        'transform': `scale(${scale},${scale}) translate(${dx}px,${dy}px)`,
        'background': `url(${url}) ${-left}px ${-top}px`,
        'transform-origin':'top left'
      };

      return style;

    }
  }
}
</script>
